import { motion } from "framer-motion";
import { Instagram, Phone, MapPin } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_35e41a85-229a-4de7-8848-5c7e95b2544d/artifacts/v7sg75h0_IMG_1869.png";
const INSTAGRAM = "https://www.instagram.com/parceriacertaimobiliaria?igsh=MWd6NzJiczE4c3c2NA==";
const WHATSAPP_NUM = "5582999393287";
const WHATSAPP_DISPLAY = "(82) 99939-3287";

export const Footer = () => {
  return (
    <footer
      className="relative bg-[#05091B] border-t border-[#D4B366]/15 pt-20 md:pt-24 pb-10"
      data-testid="footer-section"
    >
      <div className="container mx-auto px-6 md:px-12 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="grid lg:grid-cols-12 gap-10 lg:gap-16 mb-16"
        >
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img src={LOGO_URL} alt="Parceria Certa" className="h-14 w-auto" />
              <div className="flex flex-col leading-tight">
                <span className="font-display text-[#E8C97A] text-xl">Parceria Certa</span>
                <span className="text-[0.62rem] tracking-[0.3em] text-[#A2AAC2] uppercase">Imobiliária</span>
              </div>
            </div>
            <p className="text-[#A2AAC2] text-sm leading-[1.85] font-light max-w-md">
              Especialistas em locação não residencial. Conectamos imóveis comerciais,
              corporativos e industriais ao inquilino certo com estratégia, agilidade e segurança.
            </p>
          </div>

          <div className="lg:col-span-3">
            <h4 className="eyebrow mb-5">Navegação</h4>
            <ul className="space-y-3">
              {[
                { label: "Sobre", href: "#institucional" },
                { label: "Serviços", href: "#servicos" },
                { label: "Diferenciais", href: "#diferenciais" },
                { label: "Proprietários", href: "#proprietarios" },
                { label: "Empresas", href: "#empresas" },
              ].map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-[#A2AAC2] hover:text-[#E8C97A] text-sm transition-colors"
                    data-testid={`footer-nav-${l.label.toLowerCase()}`}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="eyebrow mb-5">Contato</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={`https://wa.me/${WHATSAPP_NUM}?text=${encodeURIComponent("Olá! Gostaria de mais informações.")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-[#A2AAC2] hover:text-[#E8C97A] text-sm transition-colors group"
                  data-testid="footer-whatsapp-link"
                >
                  <span className="w-9 h-9 flex items-center justify-center border border-[#D4B366]/40 group-hover:border-[#D4B366] transition-colors">
                    <Phone size={14} strokeWidth={1.5} />
                  </span>
                  {WHATSAPP_DISPLAY}
                </a>
              </li>
              <li>
                <a
                  href={INSTAGRAM}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-[#A2AAC2] hover:text-[#E8C97A] text-sm transition-colors group"
                  data-testid="footer-instagram-link"
                >
                  <span className="w-9 h-9 flex items-center justify-center border border-[#D4B366]/40 group-hover:border-[#D4B366] transition-colors">
                    <Instagram size={14} strokeWidth={1.5} />
                  </span>
                  @parceriacertaimobiliaria
                </a>
              </li>
              <li className="flex items-center gap-3 text-[#A2AAC2] text-sm">
                <span className="w-9 h-9 flex items-center justify-center border border-[#D4B366]/40">
                  <MapPin size={14} strokeWidth={1.5} />
                </span>
                Maceió · Alagoas
              </li>
            </ul>
          </div>
        </motion.div>

        <div className="pt-8 border-t border-[#D4B366]/15 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#A2AAC2]/60 text-xs tracking-wide">
            © {new Date().getFullYear()} Parceria Certa Imobiliária. Todos os direitos reservados.
          </p>
          <p className="text-[#A2AAC2]/60 text-xs tracking-[0.2em] uppercase">
            Locação Comercial · Corporativa · Industrial
          </p>
        </div>
      </div>
    </footer>
  );
};
